import { createSelector, MemoizedSelector } from '@ngrx/store';
import { StateUtils } from '@spartacus/core';
import { WishlistEntry } from '@wishlist/const';
import { StateWithWishlist, WishlistState } from '../wishlist-state';
import { getWishlistState } from './state.selectors';

const getAddWishlistEntryState: MemoizedSelector<
  StateWithWishlist,
  StateUtils.EntityLoaderState<WishlistEntry>
> = createSelector(getWishlistState, (state: WishlistState) => state.addEntry);

export const getAddWishlistEntryLoading = (entry: WishlistEntry): MemoizedSelector<StateWithWishlist, boolean> =>
  createSelector(getAddWishlistEntryState, (state: StateUtils.EntityLoaderState<WishlistEntry>) =>
    StateUtils.entityLoadingSelector(state, entry.productCode),
  );
